import { NgFor, NgIf } from '@angular/common';
import { Component, Inject, Input, NgModule, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerModule, NgxSpinnerService } from "ngx-spinner";
import { Application } from 'src/app/core/models/application';
import { CustomAction } from 'src/app/core/models/customAction';
import { ApplicationService } from 'src/app/core/services/application.service';

@Component({
  selector: 'app-custom-action',
  standalone: true,
  imports: [
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatIcon,
    ReactiveFormsModule,
    NgxSpinnerModule,
    NgIf,
    NgFor
  ],
  templateUrl: './custom-action.component.html',
  styleUrl: './custom-action.component.scss'
})
export class CustomActionComponent implements OnInit {
  actionForm: FormGroup;
 
  paramsList: string[] = [
    '$JobPath',
    '$JobSubmitUserId',
    '$JobName',
    '$SlurmJobId',
    '$JobApplication',
    '$UserId',
    '$Username',
    '$JobOutputDir',
    '$JobAppVersion',
    '$JobOutFileName',
    '$JobWorkingDirectory',
    '$JobNumber',
    '$JobAllocatedNodes',
    '$JobCores',
    '$JobCoresMin'
  ]; 
  scriptPathList: string[] = [];
  

  defaultStage = "Job Execute";
  // stageList: string[] = [
  //   'Init',
  //   'Data copy', 
  //   'Submit',
  //   'Execute'
  // ];
 
  statusList: string[] = [
    'Running',
    'Succeeded', 
    'Cancelled',
    'Failed',
    'Queued'
  ];
 
  currentCustomAction: CustomAction = new CustomAction();

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { 
      depName: string,
      userId: string,
      dialogHeader: string,
      application: Application,
      customAction: CustomAction
    },
    public dialogRef: MatDialogRef<CustomActionComponent>,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private spinner: NgxSpinnerService,
    private applicationService: ApplicationService,
  ) {}

  ngOnInit(){
    this.actionForm = this.formBuilder.group({
      id: [this.data.customAction.id],
      appId: [this.data.application.appId],
      actionName: [this.data.customAction.actionName, Validators.required],
      param: [
        this.data.customAction.param ? this.data.customAction.param.split(',') : [],
         Validators.required],
      script: [
        this.data.customAction.script, Validators.required], 
      state: [
        this.data.customAction.state ? this.data.customAction.state.split(',') : ['Active'], 
        Validators.required],
      stage: [['Job Execute']],
      status: [
        this.data.customAction.status ? this.data.customAction.status.split(',') : [], 
        Validators.required]
    });

    this.currentCustomAction.actionName = this.data.customAction.actionName;
    this.currentCustomAction.appId = this.data.customAction.appId;
    this.currentCustomAction.id = this.data.customAction.id;
    this.currentCustomAction.param = this.data.customAction.param;
    this.currentCustomAction.script = this.data.customAction.script;
    this.currentCustomAction.state = this.data.customAction.state;
    this.currentCustomAction.stage = this.data.customAction.stage;
    this.currentCustomAction.status = this.data.customAction.status;

    this.scriptPathList = this.data.application.customActionFile.split(',');
  }

  onClose(): void {
    this.dialogRef.close("Close");
  }

  onSubmit(): void {
    var customAction: CustomAction = new CustomAction(
      this.actionForm.value.id,
      this.actionForm.value.appId,
      this.actionForm.value.actionName,
      this.actionForm.value.param?.join(','),
      this.actionForm.value.script,
      this.actionForm.value.stage?.join(','),
      this.actionForm.value.state?.join(','),
      this.actionForm.value.status?.join(',')
    );

    // constructor(
    //   id:string = '', 
    //   appId:string = '',
    //   actionName: string = '',
    //   params: string = '',
    //   scriptPath: string = '',
    //   stage: string = '',
    //   state: string = '',
    //   status: string = ''
  

    if(this.data.dialogHeader.split(' ')[0] === 'Add'){
      this.applicationService.addCustomAction(this.data.depName,this.data.userId,this.data.application.appName,this.data.application.appVersionText, customAction)
      .subscribe({
        next: (response) => {
          this.snackBar.open('Custom Action Added Successfully', 'OK', {
            duration: 5000,
          });
          this.applicationService.notifyCustomActionAdded();
        },
        error: (error) => {
          console.error(error);
          this.snackBar.open('Something Went Wrong adding Custom Action', 'Close', {
            duration: 5000,
          });
        }
      })
      this.dialogRef.close(true);
    }
    else if(this.data.dialogHeader.split(' ')[0] === 'Update'){

      if(this.checkIfCustomActionIsUpdated(customAction))
      {
        this.applicationService.updateCustomAction(this.data.depName,this.data.userId,this.data.application.appName,this.data.application.appVersionText, customAction)
        .subscribe({
          next: (response) => {
            this.spinner.hide("UpdateCustomAction");
            this.dialogRef.close("Updated");
          },
          error: (error) => {
            console.error(error);
            this.spinner.hide("UpdateCustomAction");
            this.dialogRef.close("Failed");
          }
        })
        this.spinner.show("UpdateCustomAction");
      } 
      else{
        this.snackBar.open('No Changes Made', 'Close', {
          duration: 5000
        }).onAction().subscribe(() =>{
          this.dialogRef.close("Close");
        });
      }
    }
  }

  checkIfCustomActionIsUpdated(customAction: CustomAction) : boolean{
    if(
      customAction.actionName === this.currentCustomAction.actionName &&
      customAction.param === this.currentCustomAction.param &&
      customAction.script === this.currentCustomAction.script &&
      customAction.stage === this.currentCustomAction.stage &&
      customAction.state === this.currentCustomAction.state &&
      customAction.status === this.currentCustomAction.status
    ){
      return false
    }
    
    return true;
  }
}
